var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"title"},[_c('ListTitle',{attrs:{"headerNmae":_vm.headerNmae,"headerNmaeCh":_vm.headerNmaeCh}})],1),_c('p',{staticClass:"hr"}),_c('div',[_c('div',[_c('div',{staticStyle:{"line-height":"2","margin-bottom":"30px"},domProps:{"innerHTML":_vm._s(_vm.category.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }